import { WalletType } from 'api/walletTypesGroup';

export const rejectSettlement = (wallets: ReadonlyArray<WalletType>) => {
	if (!wallets) {
		return [];
	}

	return wallets.filter((el) => !el.is_settlement);
};
